import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Button from "../../components/ui/Button";

const bannerImages = [
  "/Images/banner1.jpg",
  "/Images/banner2.jpg",
  "/Images/banner3.jpg",
  "/Images/banner4.jpg",
];

export default function HeroSection() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (bannerImages.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % bannerImages.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  const currentImage = bannerImages[currentIndex] || bannerImages[0];

  return (
    <section
      className="relative flex items-center justify-center bg-aura-bg overflow-hidden"
      style={{
        minHeight: "80vh",
        backgroundColor: "#FDFDFD",
      }}
    >
      <div className="absolute inset-0 overflow-hidden" aria-hidden>
        <AnimatePresence mode="wait">
          <motion.div
            key={currentImage}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8 }}
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: `url('${currentImage}')`,
            }}
          />
        </AnimatePresence>
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/35 to-black/70" aria-hidden />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-28">
        <div className="max-w-3xl text-left">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-3 py-1 mb-5 backdrop-blur-sm">
            <span className="h-1.5 w-1.5 rounded-full bg-gold-primary" />
            <span className="font-sans text-[11px] md:text-xs font-medium uppercase tracking-[0.24em] text-white/80">
              Marketing · Events · Interiors
            </span>
          </span>

          <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-semibold text-white leading-[1.05]">
            <span className="block">Aura International</span>
            <span className="mt-2 block text-gold-primary text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-medium">
              We design the moments your brand is remembered for.
            </span>
          </h1>

          <p className="mt-5 md:mt-7 max-w-2xl font-sans text-sm md:text-lg text-white/85 leading-relaxed">
            From flagship events and launch moments to always‑on digital journeys and premium interiors,
            we partner with you to build experiences that feel considered, on‑brand, and commercially effective.
          </p>

          <div className="mt-10 md:mt-12 flex flex-col sm:flex-row gap-4 sm:gap-5 items-start">
            <Button to="/services" variant="primary" className="!bg-gold-primary !text-aura-text !border-gold-primary hover:!bg-white hover:!border-white">
              Explore our services
            </Button>
            <Button to="/contact" variant="outline" className="!bg-transparent !text-white !border-2 !border-white/80 hover:!bg-white hover:!text-aura-text">
              Discuss a project
            </Button>
          </div>

          <div className="mt-8 flex flex-wrap gap-4 text-[11px] md:text-xs font-sans text-white/75">
            <span className="flex items-center gap-2">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" />
              <span>End‑to‑end support across strategy, creative, and operations</span>
            </span>
            <span className="flex items-center gap-2">
              <span className="h-1.5 w-1.5 rounded-full bg-sky-400" />
              <span>For brands that refuse to settle for ordinary</span>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
